import type { LucideIcon } from "lucide-react";
import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";

/** Underline-style tab strip used for the skill-detail section tabs. */
export function DetailTabsList({ children }: { children: React.ReactNode }) {
  return (
    <TabsList className="h-auto w-full justify-start gap-1 overflow-x-auto rounded-none border-b border-border-1 bg-transparent p-0">
      {children}
    </TabsList>
  );
}

export function DetailTab({
  value,
  icon: Icon,
  label,
  count,
  alert = false,
}: {
  value: string;
  icon: LucideIcon;
  label: string;
  count?: number;
  alert?: boolean;
}) {
  return (
    <TabsTrigger
      value={value}
      className={cn(
        // reset the segmented base styles → flat underline tab
        "-mb-px h-auto flex-none gap-2 rounded-none border-0 border-b-2 border-transparent bg-transparent px-3.5 py-3 text-[13.5px] font-semibold whitespace-nowrap shadow-none",
        "data-[state=active]:bg-transparent data-[state=active]:shadow-none",
        alert
          ? "text-[#b5322b] data-[state=active]:border-danger data-[state=active]:text-[#b5322b]"
          : "text-fg-3 hover:text-fg-1 data-[state=active]:border-navy data-[state=active]:text-navy",
      )}
    >
      <Icon className="size-4" />
      <span>{label}</span>
      {count != null ? (
        <span
          className={cn(
            "rounded-full px-[7px] py-px text-[11px] font-bold tabular-nums",
            alert ? "bg-danger-bg text-[#b5322b]" : "bg-bg-3 text-fg-3",
          )}
        >
          {count}
        </span>
      ) : null}
    </TabsTrigger>
  );
}
